module.exports = __webpack_public_path__ + "static/media/Pharmacy.1464a9da.webp";